import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

export default class extends Controller {
  static values = {
    options: Object,
    initialValue: Object,
    producerId: Number,
    notId: Number,
    nonSample: Boolean
  }

  connect() {
    const options = {
    plugins: ['remove_button'],
    clearAfterSelect: true,
		valueField: 'id',
		labelField: 'name',
		searchField: ['name', 'unit', 'producer_name'],
    maxOptions: null,
		load: this.queryProductUnitViews.bind(this),
		render: { option: this.renderOption,
              item: this.renderItem }
    }
    this.tom = new TomSelect(this.element, options)

   if (this.hasInitialValueValue) {
      const item = this.initialValueValue
      this.tom.addOption(item)
      this.tom.setValue(item.id)
    }
  }

  disconnect() {
    if (this.tom) {
      this.tom.destroy()
    }
  }

  renderItem(option, escape) {
    let minimum = ''
    if (option.quantity_minimum > 1) {
      minimum = `<span class="badge border ml-2">${option.quantity_minimum} minimum</span>`
    }
    return `
      <div>
        <div class='d-inline-block'>
          <div class='small text-muted mr-2'>${ option.producer_name }</div>
          <div class='d-flex flex-wrap'>
            <div class="font-weight-bold mr-2">${ option.name }</div>
            <div>${ option.unit }${ minimum }</div>
          </div>
        </div>
      </div>
      `
  }

  renderOption(option, escape) {
    let availableIcon = ''
    if ( !option.published ) {
      availableIcon = `
        <span class='badge badge-pill badge-danger'>
          <span class="fa fa-toggle-off mr-1"></span>
          Unlisted
        </span>
      `
    } else if ( option.unavailable_until_description ) {
    availableIcon =
      `<span class='badge badge-pill badge-warning'>
        <span class="fa fa-clock mr-1"></span>
        ${ option.unavailable_until_description }
      </span>`
    }
    const mutedUnavailable = option.published ? "select-option" : "select-option text-muted"
    let minimum, maximum
    if (option.quantity_minimum > 1) {
      minimum = `<span class="badge border ml-2">${ option.quantity_minimum} minimum }</span>`
    }
    if (option.quantity_maximum) {
      maximum = `<span class="badge border ml-2">${option.quantity_maximum} maximum</span>`
    }
    let city_state_tag = ''
    if (option.city && option.state) {
      city_state_tag = `<small><span class='mx-2'>•</span>${option.city}, ${option.state}</small>`
    }

    return `<div class=${mutedUnavailable}>
          <div class='d-flex'>
            <div class='mr-2'>
              <img src=${option.product_photo.small_url} height="60" />
            </div>
            <div class='w-100'>
              <div class="text-muted">
                <small>${option.producer_name}</small>
                ${ city_state_tag }
              </div>
              <div class='d-flex justify-content-between'>
                <div>
                  <div class="font-weight-bold">${option.name}</div>
                  <div>${ option.unit }${ minimum || '' }${ maximum || '' }</div>
                </div>
                <div class="text-right">
                  <div>${ availableIcon }</div>
                </div>
              </div>
            </div>
          </div>
        </div>`
  }

  queryProductUnitViews(query, callback) {
    var url = '/admin/product_unit_views.json?q=' + encodeURIComponent(query);
    if (this.hasProducerIdValue) {
      url += '&producer_id=' + encodeURIComponent(this.producerIdValue);
    }
    if (this.hasNotIdValue) {
      url += '&not_id=' + encodeURIComponent(this.notIdValue);
    }
    if (this.nonSampleValue) {
      url += '&non_sample=true';
    }
			fetch(url)
				.then(response => response.json())
				.then(json => { callback(json); })
        .catch(()=>{callback();})
  }
}
